import React, { ReactNode, useMemo } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { AppPaper } from '../../layout/appPaper';
import { AppRow } from '../../layout/appRow';

interface Props {
  pageTitle: string;
  preventHide?: boolean;
  firstChildren?: ReactNode;
  secondChildren?: ReactNode;
  thirdChildren?: ReactNode;
}

const styles = {
  appRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    p: 1,
    pb: 2,
  },

  typo: {
    display: 'inline-block',
    mt: 2,
  },
  boxOne: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
  },
  boxTwo: {
    alignSelf: 'flex-center',
  },
} as const;

export function AppToolbox({
  firstChildren,
  secondChildren,
  thirdChildren,
  pageTitle,
  preventHide = false,
}: Props): JSX.Element {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const showFirstTwoChildren = useMemo(
    () => preventHide || !isMobile,

    [isMobile, preventHide]
  );

  return (
    <AppPaper isMobile={isMobile}>
      {showFirstTwoChildren && (
        <AppRow sx={styles.appRow}>
          <Box sx={styles.boxOne}>
            <Typography variant="pageTitle">{pageTitle}</Typography>
            {firstChildren}
          </Box>
          <Box sx={styles.boxTwo}>{secondChildren}</Box>
        </AppRow>
      )}
      {thirdChildren}
    </AppPaper>
  );
}
